import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SizeGuideContent, SizeGuideTabs, SizeNotice, TabLink } from '../SizeGuide.css';
import SelectableTable from '../SelectableTable';
import { mixpanelTabValue } from '../../../helpers/search_helpers';
import { track } from '../../../helpers/tracking';
import TrackingEvents from '../../../common/models/TrackingEvents';
import { Desktop, Mobile } from '../../MediaQuery';
import Departments from '../../../common/models/Departments';
import { babyKids, juniorKids, men, women } from './departmentDataHelpers';

class SizeGuideByDepartment extends Component {
  constructor(props) {
    super(props);
    const { defaultTab } = props;

    this.state = {
      opened: defaultTab,
    };

    this.currentTabRef = React.createRef();
  }

  componentDidMount() {
    this.currentTabRef.current && this.currentTabRef.current.scrollIntoView();
  }

  pickDepartmentData() {
    const { department } = this.props;
    const {
      getWomenInternalName,
      getUnisexInternalName,
      getMenInternalName,
      getJuniorKidsDepartmentsInternalNames,
      getBabyKidsDepartmentsInternalNames,
    } = Departments;
    if ([getWomenInternalName(), getUnisexInternalName()].includes(department)) {
      return women();
    }
    if (department === getMenInternalName()) {
      return men();
    }
    if (
      getJuniorKidsDepartmentsInternalNames().includes(department) &&
      !getBabyKidsDepartmentsInternalNames().includes(department)
    ) {
      return juniorKids();
    }
    if (getBabyKidsDepartmentsInternalNames().includes(department)) {
      return babyKids();
    }
  }

  renderDepartmentSizeGuide(opened, sizeTabs, openAll = false) {
    // store ref only in mobile
    return sizeTabs.map(({ label, tab, contentGenerator }) => (
      <div key={label} ref={opened === tab && openAll ? this.currentTabRef : null}>
        <SelectableTable label={label} name={tab} render={opened === tab || openAll}>
          {contentGenerator()}
        </SelectableTable>
      </div>
    ));
  }

  render() {
    const { opened } = this.state;
    const sizeTabs = this.pickDepartmentData();
    return (
      <SizeGuideContent className="size_guide">
        <Desktop>
          <SizeNotice>
            Please note that this is a representative guide only. Sizes and measurements may vary depending on the style
            of the item and how the brand fits.
            <br />
            If you are not sure about a size or a fit, we recommend to try the product at a nearby luxury boutique.
          </SizeNotice>
        </Desktop>
        <div className="tabbable">
          <Desktop>
            <SizeGuideTabs className="nav nav-tabs">
              {sizeTabs.map(sizeTab => (
                <li key={`size_tab_${sizeTab.tab}`} className={opened === sizeTab.tab ? ' active' : ''}>
                  <TabLink
                    data-cy={`size-${sizeTab.tab}${opened === sizeTab.tab ? '-active' : ''}`}
                    onClick={() => {
                      track(TrackingEvents.sizeGuideTabSelected(), { ui: { tab: mixpanelTabValue(sizeTab.tab) } });
                      this.setState({ opened: sizeTab.tab });
                    }}
                    data-toggle="tab"
                  >
                    {sizeTab.label}
                  </TabLink>
                </li>
              ))}
            </SizeGuideTabs>
          </Desktop>

          <div className="tab-content">
            <Desktop>{this.renderDepartmentSizeGuide(opened, sizeTabs)}</Desktop>
            <Mobile>{this.renderDepartmentSizeGuide(opened, sizeTabs, true)}</Mobile>
          </div>
        </div>
      </SizeGuideContent>
    );
  }
}

SizeGuideByDepartment.propTypes = {
  department: PropTypes.string.isRequired,
  defaultTab: PropTypes.string,
};

export default SizeGuideByDepartment;
